import { memoize } from '@dbh/lodash-extra';

const THEME_KEY_FORM_GROUP="formGroup";const modifyFormGroupTheme=memoize(a=>{let{spacing:{sp6:b}}=a;return {[THEME_KEY_FORM_GROUP]:{display:"flex",flexDirection:"column",margin:"0 0 "+b+" 0"}}});const modifyFormGroupThemeForInlineDisplay=memoize(a=>{const{[THEME_KEY_FORM_GROUP]:b}=a;return {...a,[THEME_KEY_FORM_GROUP]:{...b,flexDirection:"row"}}});

export { THEME_KEY_FORM_GROUP, modifyFormGroupTheme as default, modifyFormGroupThemeForInlineDisplay };
